import { useCallback, useRef } from "react";
import { EventSource, metricsBus, OfModuleShownEvent } from "@/common/buses";
import { useAnalyticsStore } from "@/common/store/analyticsStore";
import { getEventDevice } from "@/common/utils/device";

export const useOfModuleImpression = (placement: OfModuleShownEvent["placement"]) => {
  const eventSource = useAnalyticsStore((state) => state.eventSource);
  const sentRef = useRef(false);

  return useCallback(() => {
    if (sentRef.current) {
      return;
    }

    sentRef.current = true;

    metricsBus.emit("ofModuleShown", {
      placement,
      device: getEventDevice(),
      source: eventSource?.name ?? EventSource.Other,
    });
  }, [placement, eventSource?.name]);
};
